import { render } from "./CustomerList.vue?vue&type=template&id=7cb2c6e4&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=7cb2c6e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb2c6e4"]])

export default __exports__